// Components
import { MainDiv, Title, GrayText, EmotionalAlignerDiv, EmotionalAnswerDiv, EmotionalValue, Span, EmotionalText } from "./styles";

const RecentWellBeingAssessment = ({ lastEmotionalAnswer }) => {
  const renderEmotionalAnswer = (isPositiveAnswer, key, label) => {
    const emotionalAnswers = lastEmotionalAnswer.filter((emotionalAnswer) => emotionalAnswer.EMOTIONAL_QUESTION_KEY === key);
    const isThereSomeEmotionalAnswer = Boolean(emotionalAnswers.length);

    const emotionalAnswersSum = emotionalAnswers.reduce(
      (accumulator, emotionalAnswer) => accumulator + Number(emotionalAnswer.EMOTIONAL_ANSWER),
      0
    );

    const emotionalAnswerValue = isThereSomeEmotionalAnswer ? emotionalAnswersSum / emotionalAnswers.length : "-";

    const isMoreThanHalf = isThereSomeEmotionalAnswer ? (isPositiveAnswer ? emotionalAnswerValue < 5 : emotionalAnswerValue > 5) : false;

    const color = isMoreThanHalf ? "#F15A24" : "#000";

    return (
      <EmotionalAnswerDiv
        border={isMoreThanHalf ? "1px solid #F15A24" : "none"}
        background={isMoreThanHalf ? "#efe3de" : "rgba(242, 242, 242, 0.95)"}
      >
        <EmotionalValue color={color}>
          {emotionalAnswerValue.toString().length > 3 ? emotionalAnswerValue.toString().substring(0, 3) : emotionalAnswerValue}{" "}
          {isThereSomeEmotionalAnswer && <Span>/ 10</Span>}
        </EmotionalValue>
        <EmotionalText color={color}>{label}</EmotionalText>
      </EmotionalAnswerDiv>
    );
  };

  return (
    <MainDiv>
      <Title>Recent Self-Reported Well-Being Assessment</Title>
      <GrayText>
        Recent results from a self-reported emotional slider, completed directly by the patient. These values rect the patient’s personal
        perception of their current well-being:
      </GrayText>
      <EmotionalAlignerDiv>
        {renderEmotionalAnswer(false, "pain", "Pain")}
        {renderEmotionalAnswer(false, "energy", "Fatigue")}
        {renderEmotionalAnswer(true, "mood", "Happiness")}
      </EmotionalAlignerDiv>
    </MainDiv>
  );
};

export default RecentWellBeingAssessment;
